var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnectBankIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 141,
    viewBox: "0 0 300 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3943_12232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H292C296.418 0 300 3.58172 300 8V141H0V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1336,
    cy: 143.625,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.2435,
    cy: 29.4929,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-58.9547 19.2435 29.4929)",
    fill: "#F7FFAE",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.921,
    cy: 35.07,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-58.9547 149.921 35.07)",
    fill: "#F7FFAE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.586,
    cy: 36.664,
    rx: 85.266,
    ry: 73.9044,
    transform: "rotate(-149.336 233.586 36.664)",
    fill: "#F7FFAE",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3943_12232)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 276,
    height: 209,
    rx: 4.78088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5008,
    cy: 110.956,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_3943_12232)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.652,
    cy: 110.841,
    rx: 103.652,
    ry: 89.8406,
    fill: "#E6FF00",
    fillOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 54.1836,
    y: 53.7842,
    width: 276.096,
    height: 190.04,
    rx: 4.78088,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3943_12232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.803 81.1448C165.803 81.1448 158.084 69.2448 151.973 69.8895C145.861 70.5343 146.184 75.0336 143.931 78.5728C141.677 82.1119 138.142 76.9644 134.617 78.2504C131.092 79.5364 132.364 81.7895 130.114 82.7532C127.864 83.7168 122.713 78.5728 120.8 80.1812C118.888 81.7895 118.225 84.3616 116.939 85.0063C115.653 85.6511 113.081 83.3979 111.795 85.0063L110.509 86.6147H173.555C173.555 86.6147 174.519 83.0756 171.947 81.4672C169.375 79.8588 168.698 81.7895 165.803 81.1448Z",
    fill: "#EBEBEB",
    fillOpacity: 0.4,
    stroke: "#EBEBEB",
    strokeOpacity: 0.4,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.738 89.8566C269.738 89.8566 265.891 83.9138 262.846 84.2469C259.801 84.58 259.948 86.8117 258.841 88.5706C257.734 90.3294 255.976 87.7682 254.185 88.4094C252.393 89.0506 253.063 90.1718 251.942 90.6518C250.821 91.1319 248.256 88.5706 247.285 89.3694C246.315 90.1682 246.003 91.4542 245.362 91.7731C244.72 92.0919 243.442 90.9742 242.8 91.7731L242.159 92.5755H273.561C273.561 92.5755 274.041 90.813 272.758 90.0106C271.476 89.2082 271.178 90.1754 269.738 89.8566Z",
    fill: "#EBEBEB",
    fillOpacity: 0.4,
    stroke: "#EBEBEB",
    strokeOpacity: 0.4,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.497 160.799V163.621H260.965V125.163H265.35",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.497 114.946V158.678",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.665 134.366V161.354H114.541V120.929H126.889V135.043H133.595V107.876H147.354V114.933H154.411V101.17H252.498V112.497",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.665 84.1045V132.242",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0322 107.929V142.415H66.5538V76.1191H92.6643V81.8184",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 79.6475H85.6074V82.8213H88.7812V79.6475Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 85.999H85.6074V89.1728H88.7812V85.999Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 92.3496H85.6074V95.5234H88.7812V92.3496Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 98.7012H85.6074V101.875H88.7812V98.7012Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 105.053H85.6074V108.227H88.7812V105.053Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 111.403H85.6074V114.577H88.7812V111.403Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 117.755H85.6074V120.929H88.7812V117.755Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 124.106H85.6074V127.28H88.7812V124.106Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 130.984H85.6074V134.158H88.7812V130.984Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7812 137.335H85.6074V140.509H88.7812V137.335Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 105.933H245.616V109.106H248.79V105.933Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 112.285H245.616V115.459H248.79V112.285Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 118.635H245.616V121.809H248.79V118.635Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 124.987H245.616V128.161H248.79V124.987Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 131.338H245.616V134.512H248.79V131.338Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.79 137.688H245.616V140.862H248.79V137.688Z",
    stroke: "#E2E2DD",
    strokeOpacity: 0.6,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.586 101H108.542V110.174H176.586V101Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.582 101H139.929V110.174H176.582V101Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.933 100.963H134.903V110.18H139.933V100.963Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94 100.963H139.91V110.18H144.94V100.963Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.571 100.963H108.542V110.18H113.571V100.963Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.585 100.963H171.556V110.18H176.585V100.963Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.208 94.8203H107.059V102.92H140.208V94.8203Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.197 94.8203H139.929V102.92H178.197V94.8203Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.586 117.188H108.542V126.362H176.586V117.188Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.582 117.188H139.929V126.362H176.582V117.188Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.586 133.375H108.542V142.549H176.586V133.375Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.582 133.375H139.929V142.549H176.582V133.375Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.933 116.273H134.903V125.49H139.933V116.273Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94 116.273H139.91V125.49H144.94V116.273Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.571 116.273H108.542V125.49H113.571V116.273Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.585 116.273H171.556V125.49H176.585V116.273Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.208 110.127H107.059V118.226H140.208V110.127Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.197 110.127H139.929V118.226H178.197V110.127Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.933 131.584H134.903V140.801H139.933V131.584Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.94 131.584H139.91V140.801H144.94V131.584Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.571 131.584H108.542V140.801H113.571V131.584Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.585 131.584H171.556V140.801H176.585V131.584Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.208 125.438H107.059V133.537H140.208V125.438Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.197 125.438H139.929V133.537H178.197V125.438Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.208 140.747H107.059V148.846H140.208V140.747Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.197 140.747H139.929V148.846H178.197V140.747Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 78.7109H163.402V89.436H242.955V78.7109Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 78.7109H200.102V89.436H242.955V78.7109Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 78.6689H194.224V89.4441H200.102V78.6689Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.955 78.6689H200.077V89.4441H205.955V78.6689Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.281 78.6689H163.402V89.4441H169.281V78.6689Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.956 78.6689H237.077V89.4441H242.956V78.6689Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.432 71.4824H161.673V80.9537H200.432V71.4824Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.843 71.4824H200.102V80.9537H244.843V71.4824Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 97.6357H163.402V108.361H242.955V97.6357Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 97.6357H200.102V108.361H242.955V97.6357Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 116.561H163.402V127.286H242.955V116.561Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 116.561H200.102V127.286H242.955V116.561Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 133.447H163.402V144.172H242.955V133.447Z",
    fill: "white",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 133.447H200.102V144.172H242.955V133.447Z",
    fill: "#C9C9C9",
    fillOpacity: 0.3,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 96.5684H194.224V107.344H200.102V96.5684Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.955 96.5684H200.077V107.344H205.955V96.5684Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.281 96.5684H163.402V107.344H169.281V96.5684Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.956 96.5684H237.077V107.344H242.956V96.5684Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.432 89.3828H161.673V98.8541H200.432V89.3828Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.843 89.3828H200.102V98.8541H244.843V89.3828Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 114.465H194.224V125.24H200.102V114.465Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.955 114.465H200.077V125.24H205.955V114.465Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.281 114.465H163.402V125.24H169.281V114.465Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.956 114.465H237.077V125.24H242.956V114.465Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.432 107.283H161.673V116.754H200.432V107.283Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.843 107.283H200.102V116.754H244.843V107.283Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.102 132.365H194.224V143.14H200.102V132.365Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.955 132.365H200.077V143.14H205.955V132.365Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.281 132.365H163.402V143.14H169.281V132.365Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.956 132.365H237.077V143.14H242.956V132.365Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.432 125.179H161.673V134.65H200.432V125.179Z",
    fill: "#181B01",
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.843 125.179H200.102V134.65H244.843V125.179Z",
    fill: "#E6FF00",
    fillOpacity: 0.7,
    stroke: "#E6FF00",
    strokeOpacity: 0.7,
    strokeWidth: 0.358218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.607 78.4512V74.1812H213.412C213.706 74.1812 213.959 74.2309 214.169 74.3302C214.379 74.4296 214.539 74.5729 214.65 74.7601C214.761 74.9435 214.816 75.167 214.816 75.4307C214.816 75.6179 214.765 75.7975 214.662 75.9694C214.559 76.1376 214.388 76.2789 214.152 76.3936V75.958C214.377 76.0459 214.551 76.1509 214.673 76.2732C214.795 76.3955 214.879 76.5292 214.925 76.6744C214.971 76.8158 214.994 76.9648 214.994 77.1215C214.994 77.5418 214.855 77.8685 214.576 78.1016C214.297 78.3346 213.909 78.4512 213.412 78.4512H211.607ZM212.495 77.6774H213.515C213.695 77.6774 213.838 77.6258 213.945 77.5227C214.052 77.4195 214.106 77.2858 214.106 77.1215C214.106 76.9533 214.052 76.8177 213.945 76.7145C213.838 76.6114 213.695 76.5598 213.515 76.5598H212.495V77.6774ZM212.495 75.786H213.475C213.613 75.786 213.722 75.7478 213.802 75.6714C213.886 75.5912 213.928 75.4861 213.928 75.3562C213.928 75.2263 213.886 75.1231 213.802 75.0467C213.722 74.9664 213.613 74.9263 213.475 74.9263H212.495V75.786ZM216.47 78.5199C216.244 78.5199 216.049 78.4837 215.885 78.4111C215.721 78.3385 215.595 78.2353 215.507 78.1016C215.419 77.964 215.375 77.8016 215.375 77.6144C215.375 77.4386 215.415 77.2839 215.495 77.1501C215.575 77.0126 215.698 76.8979 215.862 76.8062C216.03 76.7145 216.238 76.6496 216.487 76.6114L217.444 76.4566V77.0871L216.642 77.2304C216.519 77.2533 216.426 77.2934 216.361 77.3507C216.296 77.4042 216.263 77.4826 216.263 77.5857C216.263 77.6812 216.3 77.7558 216.372 77.8092C216.445 77.8627 216.535 77.8895 216.642 77.8895C216.783 77.8895 216.907 77.8589 217.014 77.7978C217.121 77.7366 217.203 77.6545 217.261 77.5513C217.322 77.4443 217.352 77.3278 217.352 77.2017V76.3878C217.352 76.2694 217.304 76.17 217.209 76.0898C217.117 76.0096 216.991 75.9694 216.831 75.9694C216.678 75.9694 216.542 76.0115 216.424 76.0955C216.309 76.1796 216.225 76.2904 216.172 76.428L215.484 76.1013C215.545 75.9255 215.642 75.7746 215.776 75.6485C215.91 75.5224 216.07 75.4249 216.257 75.3562C216.445 75.2874 216.649 75.253 216.871 75.253C217.134 75.253 217.367 75.3008 217.57 75.3963C217.773 75.4918 217.929 75.6255 218.04 75.7975C218.155 75.9656 218.212 76.1624 218.212 76.3878V78.4512H217.41V77.9468L217.604 77.9124C217.513 78.05 217.411 78.1646 217.301 78.2563C217.19 78.3442 217.066 78.4091 216.928 78.4512C216.791 78.497 216.638 78.5199 216.47 78.5199ZM218.842 78.4512V75.3218H219.645V75.9408L219.599 75.8032C219.672 75.616 219.788 75.4784 219.949 75.3906C220.113 75.2989 220.304 75.253 220.522 75.253C220.759 75.253 220.965 75.3027 221.141 75.402C221.32 75.5014 221.46 75.6408 221.559 75.8204C221.659 75.9962 221.708 76.2025 221.708 76.4394V78.4512H220.848V76.6228C220.848 76.5006 220.824 76.3955 220.774 76.3076C220.728 76.2197 220.661 76.1509 220.573 76.1013C220.489 76.0516 220.39 76.0268 220.275 76.0268C220.165 76.0268 220.065 76.0516 219.977 76.1013C219.889 76.1509 219.821 76.2197 219.771 76.3076C219.725 76.3955 219.702 76.5006 219.702 76.6228V78.4512H218.842ZM222.273 78.4512V74.1124H223.133V76.8922L222.812 76.789L224.194 75.3218H225.254L224.119 76.5827L225.248 78.4512H224.274L223.328 76.8635L223.827 76.7375L222.87 77.7806L223.133 77.2819V78.4512H222.273Z",
    fill: "#181B01"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3943_12232",
    x: -123.134,
    y: 1.16887,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3943_12232",
    x: -101.136,
    y: -96.2036,
    width: 240.758,
    height: 251.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3943_12232",
    x: 29.542,
    y: -90.6265,
    width: 240.758,
    height: 251.393,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3943_12232",
    x: 107.825,
    y: -83.6465,
    width: 251.521,
    height: 240.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.6411,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3943_12232",
    x: -114.767,
    y: -31.5001,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_3943_12232",
    x: 48.3847,
    y: -31.6153,
    width: 312.535,
    height: 284.912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26.3077,
    result: "effect1_foregroundBlur_3943_12232"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3943_12232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H292C296.418 0 300 3.58172 300 8V141H0V8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3943_12232"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 276,
    height: 209,
    rx: 4.78088,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3943_12232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 173.841,
    height: 178,
    fill: "white",
    transform: "translate(85 54)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectBankIcon);
export default __webpack_public_path__ + "static/media/connect-bank-icon.5eda1517d28f58abc683e03e7a60c619.svg";
export { ForwardRef as ReactComponent };